import { render, staticRenderFns } from "./ManageRoutes.vue?vue&type=template&id=5ec87910"
import script from "./ManageRoutes.vue?vue&type=script&lang=js"
export * from "./ManageRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec87910')) {
      api.createRecord('5ec87910', component.options)
    } else {
      api.reload('5ec87910', component.options)
    }
    module.hot.accept("./ManageRoutes.vue?vue&type=template&id=5ec87910", function () {
      api.rerender('5ec87910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/spread-viewer-options/spread-viewer-routes-options/ManageRoutes.vue"
export default component.exports